import React, { FC } from 'react';

import { BaiduMap, BaiduMapMarker } from '@marriott/mi-ui-library';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

import { BaiduMapViewProps } from './BaiduMapView.types';
import { StyledBaiduMapView } from './BaiduMapView.styles';

export const BaiduMapView: FC<BaiduMapViewProps> = props => {
  const mapCenter = {
    lat: props?.latitude || 0,
    lng: props?.longitude || 0,
  };
  // Marker position based on latitude and longitude
  const markerPosition = { lat: props?.latitude || 0, lng: props?.longitude || 0 };
  const clientEnvVars = useClientEnvVarsStore.getState().envVarsObject;
  const { BAIDU_MAP_API_KEY: apiKey } = clientEnvVars;

  return (
    <StyledBaiduMapView data-component-name="m-account-BaiduMapView">
      <div data-testid="account-BaiduMapView" className="g-map-container">
        <BaiduMap
          apiKey={apiKey}
          zoom={10}
          center={mapCenter}
          panoramaControl={false}
          mapControlProps={{ offset: { width: 10, height: 10 } }} // check its use
          children={
            <BaiduMapMarker id="baidu-marker" position={markerPosition} className="labels icon-l pb-1">
              <span className="icon-l icon-status-cobalt"></span>
            </BaiduMapMarker>
          }
          style={{
            height: '100%',
            width: '100% ',
            borderRadius: '1rem',
          }}
        />
      </div>
    </StyledBaiduMapView>
  );
};
